/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S1_Provider_AInputs */

const tr_mesafeli_s1_provider_a = /** @type {(inputs: Mesafeli_S1_Provider_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse® E-Ticaret Limited Şirketi (kısaca "Emonse®" veya "ShopPanel™"); Pınarbaşı Mah. 740 Sk. Ülker Apt. No: 3 İç Kapı No: 10, 07070 Konyaaltı / Antalya; Antalya Ticaret Sicil No 139493; MERSİS No: 0334126673600001; Vergi Dairesi Antalya Kurumlar; VKN`)
};

const en_mesafeli_s1_provider_a = /** @type {(inputs: Mesafeli_S1_Provider_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse® E-Ticaret Limited Şirketi (in short "Emonse®" or "ShopPanel™"); Pınarbaşı Mah. 740 Sk. Ülker Apt. No: 3 İç Kapı No: 10, 07070 Konyaaltı / Antalya; Ticaret Sicil Antalya No. 139493; MERSİS No.: 0334126673600001; Tax Office Antalya Kurumlar; VKN`)
};

const de_mesafeli_s1_provider_a = /** @type {(inputs: Mesafeli_S1_Provider_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse® E-Ticaret Limited Şirketi (kurz "Emonse®" oder "ShopPanel™"); Pınarbaşı Mah. 740 Sk. Ülker Apt. No: 3 İç Kapı No: 10, 07070 Konyaaltı / Antalya; Ticaret Sicil Antalya Nr. 139493; MERSİS Nr.: 0334126673600001; Finanzamt Antalya Kurumlar; VKN`)
};

const ru_mesafeli_s1_provider_a = /** @type {(inputs: Mesafeli_S1_Provider_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse® E-Ticaret Limited Şirketi (кратко «Emonse®» или «ShopPanel™»); Pınarbaşı Mah. 740 Sk. Ülker Apt. No: 3 İç Kapı No: 10, 07070 Konyaaltı / Antalya; Ticaret Sicil Antalya № 139493; MERSİS №: 0334126673600001; налоговая инспекция Antalya Kurumlar; VKN`)
};

/**
* | output |
* | --- |
* | "Emonse® E-Ticaret Limited Şirketi (in short \"Emonse®\" or \"ShopPanel™\"); Pınarbaşı Mah. 740 Sk. Ülker Apt. No: 3 İç Kapı No: 10, 07070 Konyaaltı / Antalya; Ti..." |
*
* @param {Mesafeli_S1_Provider_AInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s1_provider_a = /** @type {((inputs?: Mesafeli_S1_Provider_AInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S1_Provider_AInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s1_provider_a(inputs)
	if (locale === "de") return de_mesafeli_s1_provider_a(inputs)
	if (locale === "ru") return ru_mesafeli_s1_provider_a(inputs)
	return tr_mesafeli_s1_provider_a(inputs)
});